import React from 'react';
import { useNavigate } from 'react-router-dom';
import {ClientStatus} from "../models/enums/ClientStatus";

interface DashboardCardProps {
    label: string;
    value: number;
    route: string;
    navigateState?: NavigateState;
}

interface StateFilters {
    status?: ClientStatus
}

interface NavigateState {
    filters?: StateFilters
}

const DashboardCard: React.FC<DashboardCardProps> = ({ label, value, route, navigateState }) => {
    const navigate = useNavigate();

    return (
        <div
            className="bg-white shadow-md rounded-lg p-6 hover:shadow-lg transition cursor-pointer border border-gray-200"
            onClick={() => navigate(route, {state: navigateState})}
            role="button"
            aria-label={`${label} card`}
        >
            <div className="text-sm text-gray-500">{label}</div>
            <div className="text-2xl font-bold text-crumbblue">{value}</div>
        </div>
    );
};

export default DashboardCard;